module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "EP"
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("You could learn as much at the Hotel Florida in those years as you could learn anywhere in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—Ernest Hemingway")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Cómo se pasa la vida,")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Cómo se viene la muerte.")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Tan callando:")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Cuán presto se va el placer,")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Cómo, después de acordado,")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Da dolor,")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Cómo, a nuestro parecer,")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Cualquier tiempo pasado")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Fué mejor.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC-L"
  }, [_vm._v("—Jorge Manrique")]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("For what is a man profited, if he shall gain the whole world, and lose his own soul?")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—Matthew 16:26")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0